module.exports = __webpack_public_path__ + "img/maluly-jr-advogados-logo.5fbb7a51.webp";